module.exports = __webpack_public_path__ + "static/media/icon_08.50ded88e.png";